import { AfterViewInit, Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import * as $ from 'jquery';
import { NavBarComponent } from '../../components/nav-bar/nav-bar';
import { FaqViewerComponent } from '../../components/faq-viewer/faq-viewer';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

/**
 * Generated class for the FaqPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-faq',
  templateUrl: 'faq.html',
  styleUrls: ['./faq.scss'],
  standalone: false,
  imports: [
    IonicModule,
//    NavBarComponent,
    FaqViewerComponent,
    CommonModule,
    FormsModule,
    TranslateModule
  ]
})
export class FaqPage implements OnInit, AfterViewInit {
  public static PATH: string = 'faq';

 randomNumber: string;

  public frameheight: number = 600; 
  constructor(
    public http: HttpClient
  ) {

    this.randomNumber = '' + performance.now();
    this.log('random number = ' + this.randomNumber);
      this.frameheight = window.innerHeight;
      this.log('frameheight = ' + this.frameheight);
  }

  ionViewCanEnter(): boolean {
    this.log('ionViewCanEnter called');
    return true;
  }
  ngOnInit() {
    this.log('ngOnInit called');
  }
  ngAfterViewInit() {
    this.log('ngAfterViewInit called');
    let fh: string = "" + this.frameheight + "px"

    this.log('setting height to ' + fh);
  
    $('.iframe-wrapper').height(fh);
    $('iframe').attr('src','https://www.beerhive.com/faqs_app/?x=' + this.randomNumber);
    $('iframe').height(fh);
    
  }

  log(s: string) {
    console.log((new Date()).toString() + ' - faq - ' + s);
  }
}
